import { Component } from '@angular/core';

@Component({
  selector: 'pioneer-external-login-expired',
  templateUrl: './external-login-expired.component.html'
})
export class ExternalLoginExpiredComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.ts